import { baseApi } from './baseApi';
import type { GetAllLicensesResponse } from '../types/keyLicense';

export const keyLicenseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLicenses: builder.query<
      GetAllLicensesResponse,
      {
        pageNo?: number;
        pagesize?: number;
        pagination_required?: boolean;
      }
    >({
      query: (args) => ({
        url: '/keyLicense/getAllLicenses',
        params: {
          pageNo: args?.pageNo,
          pagesize: args?.pagesize,
          pagination_required: args?.pagination_required ?? false,
        },
      }),
      providesTags: ['KeyLicenses'],
    }),
  }),
});

export const { useGetAllLicensesQuery } = keyLicenseApi;
